export default () => ({
  showModalDetails: false,
  showButtonProfile: false,
  showButtonDetails: false
})



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/upcoming/components/resources/data.js